import { formatWageSummary } from "@/features/organization-wage-sets/utils/wage-fields";
import type { OrganizationWageSetWages } from "@/features/organization-wage-sets/utils/wage-fields";

interface OrganizationWageSetOptionLabelProps {
  name: string;
  wages: OrganizationWageSetWages;
}

/** A wage set's name above a one-line summary of its wages. */
export function OrganizationWageSetOptionLabel({
  name,
  wages,
}: OrganizationWageSetOptionLabelProps) {
  return (
    <span className="flex min-w-0 flex-col items-start text-left">
      <span className="max-w-full truncate font-medium">{name}</span>
      <span className="max-w-full text-xs text-slate-500">
        {formatWageSummary(wages)}
      </span>
    </span>
  );
}
